<template>
<div v-if="ready" style="padding:20px 20px 20px 20px;">
<schedaHeader scheda="1" titolo="DATI GENERALI" :item="item"></schedaHeader>

  <el-form ref="formBasic" :model="item.row" @submit.native.prevent="onSubmit" :rules="rulesForm" label-width="360px" class="label-50">



    <div class="formRow row" style="">
      
      <div class="col s12" v-if="$centro._struttura.von>0" >
      <formLabel variabile="vonnumber"></formLabel>
      <el-form-item prop="vonnumber">
      <formRangeV3 v-model="item.row.vonnumber" variabile="vonnumber"></formRangeV3>
      </el-form-item>
      </div>
      


      <div class="formCol col s12">
      <formLabel variabile="ncartellaclinica"></formLabel>
      <el-form-item prop="ncartellaclinica" >   
      <formRangeV3 v-model="item.row.ncartellaclinica" variabile="ncartellaclinica"></formRangeV3>
      </el-form-item>
      </div> 

      <!--
      <div class="formCol col s12">
      <formLabel variabile="byear"></formLabel>
      <el-form-item prop="byear">
      <formRangeV3 v-model="item.row.byear" variabile="byear"></formRangeV3>
      </el-form-item>
      </div>
      -->

      <div class="formCol col s12">
      <formLabel variabile="cognome"></formLabel>
      <el-form-item prop="cognome">
      <el-input  v-model="item.row.cognome" class="capitalize" @input="lower('cognome')"></el-input>
      </el-form-item>
      </div> 

      <div class="formCol col s12">
      <formLabel variabile="nome"></formLabel>
      <el-form-item prop="nome">
      <el-input  v-model="item.row.nome" class="capitalize" @input="lower('nome')"></el-input>
      </el-form-item>
      </div>

      <div class="col s12" >
      <formLabel variabile="sex"></formLabel>
      <el-form-item prop="sex">
      <formSelectV3 v-model="item.row.sex" variabile="sex" v-on:change="sga()"></formSelectV3>
      </el-form-item>
      </div>

      <div class="col s12" >
      <formLabel variabile="primogenito"></formLabel>
      <el-form-item prop="primogenito">
      <formSelectV3 v-model="item.row.primogenito" variabile="primogenito" v-on:change="sga()"></formSelectV3>
      </el-form-item>
      </div>

      <div class="col s12" >
      <formLabel variabile="datanascita"></formLabel>
      <el-form-item prop="datanascita">
      <el-date-picker v-model="item.row.datanascita" type="date" placeholder="Indica la data" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd" ></el-date-picker>
      </el-form-item>
      </div>
      
      <div class="col s12" >
      <formLabel variabile="locate"></formLabel>
      <el-form-item prop="locate">
      <formSelectV3 v-model="item.row.locate" variabile="locate"></formSelectV3>
      </el-form-item>
      </div>

      <div class="col s12" v-if="item.row.locate==1">
      <formLabel variabile="dataricovero"></formLabel>
      <el-form-item prop="dataricovero">
      <el-date-picker v-model="item.row.dataricovero" type="date" placeholder="Indica la data" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd" ></el-date-picker>
      </el-form-item>
      </div>
<!--
      <div class="col s12" v-if="item.row.locate==1">
      <formLabel variabile="dayadmiss"></formLabel>
      <el-form-item prop="dayadmiss">
      <formRangeV3 v-model="item.row.dayadmiss" variabile="dayadmiss"></formRangeV3>
      </el-form-item>
      </div>
-->

      <div class="col s12" v-if="item.row.locate==1">
      <formLabel variabile="outb_ctr"></formLabel>
      <el-form-item prop="outb_ctr" >
        <el-select v-model="item.row.outb_ctr"  placeholder="Selezionare dalla lista" style="width:100%;" clearable filterable>
          <el-option label="Altro centro" :value="-5"></el-option>
          <el-option label="Nato in casa" :value="-98"></el-option>
          <el-option label="Nato in transito" :value="-97"></el-option>
          <el-option v-for="itm in $teras._struttura" :key="itm.id" :label="itm.id+' - '+itm.nome+' - '+itm.regione+' - '+itm.citta" :value="itm.id" >
            <span style="float: left">{{ itm.id }} - {{ itm.nome }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ itm.regione }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      </div> 

      <div class="col s12" v-if="item.row.locate==1">       
      <formLabel variabile="transcodein"></formLabel>       
      <el-form-item prop="transcodein">       
      <formSelectV3 v-model="item.row.transcodein" variabile="transcodein"></formSelectV3>       
      </el-form-item>       
      </div>



      <div class="col s12" v-if="item.row.locate==0">
      <formLabel variabile="deldie"></formLabel>
      <el-form-item prop="deldie">
      <formSelectV3 v-on:change="changeDeldie()" v-model="item.row.deldie" variabile="deldie"></formSelectV3>
      </el-form-item>
      </div>
 

      <div class="col s12" >
      <formLabel variabile="gaweeks"></formLabel>
      <el-form-item prop="gaweeks">
      <formRangeV3 v-model="item.row.gaweeks" variabile="gaweeks" v-on:change="sga()"></formRangeV3>
      </el-form-item>
      </div>

      <div class="col s12" >
      <formLabel variabile="gadays"></formLabel>
      <el-form-item prop="gadays">
      <formRangeV3 v-model="item.row.gadays" variabile="gadays"></formRangeV3>
      </el-form-item>
      </div>

      <div class="col s12" >
      <formLabel variabile="bwgt" :gruppo="$centro.lastGRUPPO"></formLabel>
      <el-form-item prop="bwgt">
      <formRangeV3 v-model="item.row.bwgt" variabile="bwgt" v-on:change="sga()"></formRangeV3>
      </el-form-item>
      </div>

      <!--
        <div class="col s12" v-if="item.row.bwgt>0 && item.row.gaweeks>0">

      <div class="yo-align-left" style="padding-left:12px;" >{{$centro.lastGRUPPO}}</div>

      </div>
      -->


      <div class="col s12" v-if="item.row.sex>-1 && item.row.gaweeks>-1 && item.row.bwgt>-1">
      <formLabel variabile="sga"></formLabel>
      <el-form-item prop="sga">
      <div class="yo-align-left" style="padding-left:12px;" :class="{red:sgaValue=='tra 3° e 10° percentile' || sgaValue =='< 3° percentile'}">{{sgaValue}}</div>
      </el-form-item>
      </div>

      <div class="col s12" >
      <formLabel variabile="lunghezzanascita"></formLabel>
      <el-form-item prop="lunghezzanascita">
      <formRangeV3 v-model="item.row.lunghezzanascita" variabile="lunghezzanascita"></formRangeV3>
      </el-form-item>
      </div>


      <div class="col s12" >
      <formLabel variabile="bheadcir"></formLabel>
      <el-form-item prop="bheadcir">
      <formRangeV3 v-model="item.row.bheadcir" variabile="bheadcir"></formRangeV3>
      </el-form-item>
      </div>

      <div class="col s12" v-if="$teras.objectfromarray($teras._variabile,'etamaterna','nome','isgruppo')">
      <formLabel variabile="etamaterna"></formLabel>
      <el-form-item prop="etamaterna">
      <formRangeV3 v-model="item.row.etamaterna" variabile="etamaterna"></formRangeV3>
      </el-form-item>
      </div>

      <div class="col s12" v-if="$teras.objectfromarray($teras._variabile,'hisp','nome','isgruppo')">
      <formLabel variabile="hisp"></formLabel>
      <el-form-item prop="hisp">
      <formSelectV3 v-model="item.row.hisp" variabile="hisp"></formSelectV3>
      </el-form-item>
      </div>

      <div class="col s12" v-if="$teras.objectfromarray($teras._variabile,'matrace','nome','isgruppo')">
      <formLabel variabile="matrace"></formLabel>
      <el-form-item prop="matrace">
      <formSelectV3 v-model="item.row.matrace" variabile="matrace"></formSelectV3>
      </el-form-item>
      </div>

      <div class="col s12" v-if="$teras.objectfromarray($teras._variabile,'statomadre','nome','isgruppo')">
      <formLabel variabile="statomadre"></formLabel>
      <el-form-item prop="statomadre">
      <formSelectV3 v-model="item.row.statomadre" variabile="statomadre"></formSelectV3>
      </el-form-item>
      </div>

      <div class="col s12" v-if="$teras.objectfromarray($teras._variabile,'titolomadre','nome','isgruppo')">
      <formLabel variabile="titolomadre"></formLabel>
      <el-form-item prop="titolomadre">
      <formSelectV3 v-model="item.row.titolomadre" variabile="titolomadre"></formSelectV3>
      </el-form-item>
      </div>

      <div class="col s12" v-if="$teras.objectfromarray($teras._variabile,'hmadre','nome','isgruppo')">
      <formLabel variabile="hmadre"></formLabel>
      <el-form-item prop="hmadre">
      <formRangeV3 v-model="item.row.hmadre" variabile="hmadre"></formRangeV3>
      </el-form-item>
      </div>

      <div class="col s12" v-if="$teras.objectfromarray($teras._variabile,'pmadre','nome','isgruppo')">
      <formLabel variabile="pmadre"></formLabel>
      <el-form-item prop="pmadre">
      <formRangeV3 v-model="item.row.pmadre" variabile="pmadre"></formRangeV3>
      </el-form-item>
      </div>

      <div class="col s12" v-if="item.row.pmadre>0 && item.row.hmadre>0">
      <formLabel variabile="bmimadre"></formLabel>
      <el-form-item prop="bmimadre">
      <div class="yo-align-left" style="padding-left:12px;" :class="{red:$centro.bmi(item.row.pmadre,item.row.hmadre)!='Normopeso'}" >{{$centro.bmi(item.row.pmadre,item.row.hmadre)}}</div>
      </el-form-item>
      </div>
   

      <div class="col s12" >       
        <formLabel variabile="dataesito"></formLabel>       
        <el-form-item prop="dataesito">       
          <el-date-picker v-model="item.row.dataesito" type="date" placeholder="Indica la data" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd" ></el-date-picker>       
        </el-form-item>       
      </div>



</div>

    <div class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
      <div v-if="item.row.chiusoil=='0000-00-00 00:00:00'" class="col s12 m4 offset-m8" >
        <el-button type="primary" @click="onSubmit" class="yo-bg-color-secondary" style="width:100%;border:none;">Salva e procedi</el-button>
      </div>
      <div v-else class="col s12 m4 offset-m8" >
        <el-button style="width:100%;"  @click="$router.push('/home')">Annulla</el-button>
      </div>
    </div>


  



  </el-form>



</div>
</template>

<script>
/*
QUERY
SELECT id,LOWER(nome),posizione,tipo,risposte,answer,nc,na,domanda,help FROM `variabile` WHERE scheda=1 ORDER BY posizione
*/
import schedaHeader from './Scheda-header.vue'
import formLabel from './Form-label.vue'
import formSelectV3 from './Form-select-v3.vue'
import formRangeV3 from './Form-range-v3.vue'
import formInputV3 from './Form-input-v3.vue'


import dbItem from '../teras/dbItem'

export default {
  name: 'scheda-datigenerali',
  components: {
     schedaHeader
     ,formLabel
     ,formSelectV3
     ,formRangeV3
     ,formInputV3
  },
  data() {
    return {
      loading:{}
      ,ready: false
      ,item:{}
      ,sgaValue: ''
      ,containsNumber: (rule, value, callback) => {
        let message = (typeof rule.message == 'string') ? rule.message : 'Il campo non può contenere numeri'
        if (this.$teras.containsNumber(value)) {
          callback(new Error(message));
        } else {
          callback();
        }
      }
      ,inDate: (rule, value, callback) => {
        let message = (typeof rule.message == 'string') ? rule.message : 'La data non è valida'
        if (value== '' || value== null || this.$moment(value).isBetween(rule.mindate, rule.maxdate) || this.$moment(value).isSame(rule.mindate) || this.$moment(value).isSame(rule.maxdate)) {
          callback();
        } else {
          console.log(typeof  value)
          callback(new Error(message));
        }
      }
      ,isRequired: (rule, value, callback) => {
        let message = (typeof rule.message == 'string') ? rule.message : 'La data non è valida'
        if (value!=-127 ) {
          callback();
        } else {
          callback(new Error(message));
        }
      }
    }
  },
  created: async function () {
    console.log("Arrivo  scheda-datigenerali.vue con id "+this.$route.params.id)
    this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })

    this.item = new dbItem({table:'paziente'})
    await this.item.load(this.$route.params.id)

    if(this.item.row.centro==0)
      this.item.row.centro = this.$centro.referente.row.centro

    console.error(this.$centro.referente)
    console.error(this.$teras.utente)

    if(this.item.rowIsNew){
      this.item.row.creatoil=this.$moment().format('YYYY-MM-DD H:mm:ss')
      this.item.row.creatoda=this.$teras.utente.id//this.$centro.referente.row.id
      this.item.row.chiusoil='0000-00-00 00:00:00'
      this.item.row.byear = this.$moment().format('YYYY')

      this.$axios.query('fetchOne',`SELECT MAX(ncartellaclinica)+1 FROM centro LEFT JOIN paziente ON paziente.centro=centro.id WHERE centro.id=←centro AND paziente.id>0`,{centro:this.$centro.referente.row.centro}).then((response) =>  {
        console.log(response)
        this.item.row.ncartellaclinica = response.result
      })
      /*
      this.$axios.query('fetchOne',`SELECT IF(lastvonnumber>MAX(vonnumber),lastvonnumber,MAX(vonnumber))+1 FROM centro LEFT JOIN paziente ON paziente.centro=centro.id WHERE centro.id=←centro`,{centro:this.$centro.referente.row.centro}).then((response) =>  {
        console.log(response)
        this.item.row.vonnumber = response.result
      })
      */
    }else{
      /*
      if(this.item.row.vonnumber<1){
        this.$axios.query('fetchOne',`SELECT IF(lastvonnumber>MAX(vonnumber),lastvonnumber,MAX(vonnumber))+1 FROM centro LEFT JOIN paziente ON paziente.centro=centro.id WHERE centro.id=←centro`,{centro:this.$centro.referente.row.centro}).then((response) =>  {
          console.log(response)
          this.item.row.vonnumber = response.result
        })
      }
      */

      //mettere il nome della pagina cme modifica
    }

    for (let property in this.item.row){
      if(this.item.row[property]==-7)
        this.item.row[property]=-127
    }


    this.sga()
    setTimeout(() =>{ 
      this.loading.close()
      this.ready = true 
    }, 1000)
  


  },
  methods: {
    changeDeldie: function(){
      if(this.item.row.deldie==0 && this.item.row.dataesito=='0000-00-00'){
          this.item.row.dataesito=''
      }
    },
 
    lower: function(variabile) {
      
        this.item.row[variabile] = this.item.row[variabile].toLowerCase()
    },
    sga:function(){

      let gruppo = this.$centro.tipoPaziente(this.item.row.bwgt,this.item.row.gaweeks,this.item.row.gadays)

      for(let _variabile of this.$teras._variabile){
        if(_variabile.gruppo!='1,2' && _variabile.scheda>0 && _variabile.scheda<10){
          //Find index of specific object using findIndex method.    
          let objIndex = this.$teras._variabile.findIndex((obj => obj.nome == _variabile.nome))
          //console.log(_variabile.nome)
          //console.log(objIndex)
          //Update object's name property.
          this.$teras._variabile[objIndex].isgruppo = (this.$teras.findinset(gruppo,this.$teras._variabile[objIndex].gruppo) ) ? 1 : 0

          //console.log(_variabile.nome+': '+_variabile.gruppo+' » '+_variabile.isgruppo+' » '+this.$teras._variabile[objIndex].isgruppo)
        }
        
      }



      this.$centro.sga(this.item.row.sex,this.item.row.primogenito,this.item.row.gaweeks,this.item.row.bwgt).then((response) => {
        console.log("MIRKO SGA SGA SGA SGA SGA SGA SGA"+response)
        this.sgaValue = (response== false) ? -7 : response
        this.item.row.sga = this.sgaValue
        return response
      })
    },
    onSubmit: async function() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {      
          this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })

          this.item.row.modificatoil=this.$moment().format('YYYY-MM-DD H:mm:ss')
          this.item.row.modificatoda=this.$teras.utente.id//this.$centro.referente.row.id

          let error = -1

          let checkCartella = await this.$centro.checkCartella(this.item.row.ncartellaclinica,this.item.row.datanascita,this.item.row.centro, this.item.row.id)
          if(checkCartella==false)
            error = 101

          if(this.item.row.locate==1 && this.$moment(this.item.row.dataricovero) > this.$moment(this.item.row.datanascita).add(28,'days'))
            error = 103

          if(this.item.row.locate==1 && this.$moment(this.item.row.dataricovero) > this.$moment(this.item.row.dataesito).add(0,'days'))
            error = 104

          if(this.item.row.locate==0 && this.$moment(this.item.row.datanascita) > this.$moment(this.item.row.dataesito).add(0,'days'))
            error = 105

          if(this.$moment(this.item.row.dataesito) > this.$moment(this.item.row.datanascita).add(364,'days'))
            error = 106

          if(this.item.row.gaweeks>36 && this.item.row.bwgt>1500)
            error = 107

          if(this.item.row.bheadcir>this.item.row.lunghezzanascita && this.item.row.bheadcir>0 && this.item.row.lunghezzanascita>0)
            error = 108

          if(!((this.item.row.bwgt>400 && this.item.row.bwgt<1501) || (this.item.row.gaweeks>=22 && this.item.row.gaweeks<30)))
            if(this.item.row.vonnumber>0)
              error = 109
  



          /*
          let checkVonnumber = await this.$centro.checkVonnumber(this.item.row.vonnumber,this.item.row.centro, this.item.row.id)
          if(checkVonnumber==false)
            error = 102
          */
          


          switch (error){
            case -1:
            console.log("JJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJ"+this.item.row.sga)
            if(this.item.row.sga==false)
              this.item.row.sga = -7

            if(this.item.row.chiusoil=='0000-00-00 00:00:00'){
              await this.item.save()
              await this.$axios.query('doQuery',`CALL paziente_check_risposte(←id,@nome, @numero);`,{id: this.item.row.id})
              await this.$centro.getPaziente()
              //await this.$centro.checkVonNumber()
            }
            this.$router.push('/scheda-perinatale/'+this.item.row.id)
            break;

            case 101:
            this.$notify.error({title: 'Errore '+error,message: 'La cartella clinica risulta già associata ad un altro paziente!'})
            break;

            case 102:
            this.$notify.error({title: 'Errore '+error,message: 'Il numero VON risulta già associata ad un altro paziente!'})
            break;

            case 103:
            this.$notify.error({title: 'Errore '+error,message: 'Il giorno di ricovero è superiore ai 28gg rispetto alla data di nascita, e non è compatibile con il database...guardare help!'})
            break;

            case 104:
            this.$notify.error({title: 'Errore '+error,message: 'Il giorno di ricovero non può essere superiore alla data di esito finale!'})
            break;

            case 105:
            this.$notify.error({title: 'Errore '+error,message: 'Il giorno di esito finale non può essere inferiore alla data di nascita!'})
            break;

            case 106:
            this.$notify.error({title: 'Errore '+error,message: 'Il giorno di esito deve essere minore o uguale al primo anno di età del bambino!'})
            break;

            case 107:
            this.$notify.error({title: 'Errore '+error,message: 'Il neonato non soddisfa i criteri di arruolamento. Verificare età gestionale e peso!'})
            break;

            case 108:
            this.$notify.error({title: 'Errore '+error,message: 'La circonferenza cranica non può essere maggiore della lunghezza!'})
            break;

            case 109:
            this.$notify.error({title: 'Errore '+error,message: 'Non è possibile assegnare un numero VON ad un bambino che non ha le caratteristiche richieste dal VON!'})
            break;

            default:
            this.$notify.error({title: 'Errore non specificato',message: 'Siamo spiacenti si è verificato un errore, la preghiamo di verificare i dati inseriti!'})
          }
          
          this.loading.close()

          
          
        } else {
          this.$notify.error({title: 'Errore',message: "Non tutti i campi sono stati compilati correttamente!"})
          return false
        }
      })
    }
    ,onCancel() {
        //this.$router.go(-1)
        this.$router.push('/home/')
    }

  },
  computed: {

    
    rulesForm:function() {
      var rulesNow = {
        /*
        importo: [
          //{ required: true, message: 'L\'importo è obbligatorio' },
          { min: 1, max: 5000, message: 'Bisogna indicare un importo', trigger: 'blur' }
        ],
        */
        ncartellaclinica: [
          { required: true, message: 'Il campo è obbligatorio' },
          { validator: this.isRequired, message: 'Il campo è veramente obbligatorio', trigger: 'blur'  }
        ],
        cognome: [
          { required: true, message: 'Il campo è obbligatorio'}
          ,{ validator: this.containsNumber, message: 'Il cognome non può contenere numeri', trigger: 'blur' }
        ],
        /*
        nome: [
          { required: true, message: 'Il nome del neonato è obbligatorio'},
          { validator: this.containsNumber, trigger: 'blur' }
        ],
        */
        datanascita:[
          { required: true, message: 'Il campo è obbligatorio'},
          { validator: this.inDate, mindate:this.$moment('2019-01-01'), maxdate:this.$moment(), message: 'La data deve essere un giorno del 2019 precedente ad oggi'  }

        ],
        dataricovero:[
          { validator: this.inDate, mindate:this.$moment(this.item.row.datanascita), maxdate:this.$moment(this.item.row.datanascita).add(120, 'd'), message: 'La data di ricovero deve essere successiva alla data di nascita'  }
        ],
        dataesito:[
          { validator: this.inDate, mindate:this.$moment(this.item.row.datanascita), maxdate:this.$moment(), message: 'La data di esito deve essere maggiore o uguale alla data di nascita'  }
        ],
        

        gaweeks: [
          { required: true, message: 'Il campo è obbligatorio', trigger: 'blur'},
          { validator: this.isRequired, message: 'Il campo è obbligatorio'  }
        ],
        gadays: [
          { required: true, message: 'Il campo è obbligatorio', trigger: 'blur'},
          { validator: this.isRequired, message: 'Il campo è obbligatorio'  }
        ],
        bwgt: [
          { required: true, message: 'Il campo è obbligatorio', trigger: 'blur'},
          { validator: this.isRequired, message: 'Il campo è obbligatorio'  }
        ],
        sex: [
          { required: true, message: 'Il campo è obbligatorio', trigger: 'blur'},
          { validator: this.isRequired, message: 'Il campo è obbligatorio'  }
        ],
        statomadre: [
          { required: true, message: 'Il campo è obbligatorio', trigger: 'blur'}
        ],
        hisp:[
          { required: true, message: 'Il campo è obbligatorio', trigger: 'blur'}
        ],
        matrace:[
          { required: true, message: 'Il campo è obbligatorio', trigger: 'blur'}
        ]

      }
      return rulesNow
    }
  }
}
</script>
<style >
.formRow > .col {
    background-color: #F9F9FA;
}.formRow > .col:nth-child(odd) {
    background-color: #EFF0F2;
}.formRow > .col .el-form-item{
  margin-top:10px;
  margin-bottom:18px;
}.formRow > .col .el-form-item__content{
  margin-right:12px;

  
}.formRow .capitalize input {
  text-transform: capitalize;

}
</style>